import React, { useState, useEffect, useRef } from "react";
import { environmentVariables } from "../../../config/env.config";
import { themeConfig } from "../Testimonials/config/themeConfig";
import PortfolioBox from "./PortfolioBox";

const PortfolioWrapper = ({ themeData, isExt, theme, portfolioData }) => {
  const selectedTheme = themeConfig[theme];
  const sliderRef = useRef(null);
  const [portfolios, setPortfolios] = useState([]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
  };

  useEffect(() => {
    const getSlides = () => {
      if (!themeData && !portfolioData) return null;

      if (isExt) {
        return themeData?.newGalleryImages || [];
      }

      if (themeData) {
        return themeData?.galleryData || [];
      }

      return portfolioData || [];
    };

    let slides = getSlides();

    // Duplicate slides if only 2 items, to enable infinite scroll (This is an issue with slick slider)
    if (slides.length === 2) {
      slides = [...slides, ...slides];
    }

    if (slides.length > 0) {
      const imgPrefix = environmentVariables?.s3UrlBackendUrl + "gallery/";
      const updatedImg = slides.map((item) => ({
        ...item,
        image: imgPrefix + item?.image
      }));
      setPortfolios(updatedImg);
    }
  }, [themeData, portfolioData, isExt]);

  if (!portfolios.length) return null;

  const handlePrev = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNext = () => {
    sliderRef.current?.slickNext();
  };

  let data = {
    themeData,
    portfolios,
    selectedTheme,
    theme,
    settings,
    sliderRef,
    handlePrev,
    handleNext,
  };

  return (
    <>
      <PortfolioBox {...data} />
    </>
  );
};

export default PortfolioWrapper;